"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.edit.title': 'Edytuj Onboarding',
};
